import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner } from '@onefootprint/ui';
const Verifying = t0 => {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex justify-center items-center h-8"><LoadingSpinner size="xlarge" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <div className="flex flex-col justify-center items-center h-[100px] gap-3">{t1}<p className="text-label-2 text-primary fp-text">{text}</p></div>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Verifying;